import { Menu, MenuButton, MenuItem, MenuItems, MenuSeparator } from '@headlessui/react';
import { MoreVertical } from 'lucide-react';
import { IconButton } from './Button';
import { cx } from './cx';
import styles from './ActionMenu.module.css';

/**
 * Menü mit Aktionen (⋮). items: [{ label, icon, onClick, danger, disabled } | 'separator' | falsy]
 */
export function ActionMenu({ items, label = 'Aktionen', size = 'sm' }) {
  const list = items.filter(Boolean);
  if (list.length === 0) return null;
  return (
    <Menu>
      <MenuButton as={IconButton} icon={MoreVertical} label={label} size={size} onClick={(e) => e.stopPropagation()} />
      <MenuItems anchor="bottom end" className={styles.menu} onClick={(e) => e.stopPropagation()}>
        {list.map((item, i) => (item === 'separator' ? (
          <MenuSeparator key={`sep-${i}`} className={styles.separator} />
        ) : (
          <MenuItem key={item.label} disabled={item.disabled}>
            <button type="button" disabled={item.disabled} className={cx(styles.item, item.danger && styles.danger)} onClick={item.onClick}>
              {item.icon && <item.icon aria-hidden />}
              {item.label}
            </button>
          </MenuItem>
        )))}
      </MenuItems>
    </Menu>
  );
}
